var React = require('react');

var DatePicker = require('./datepicker');
var ToggleButton = require("./ui-components/toggle-button");
var StyledSelect = require("./ui-components/styled-select");

var CheckboxGroup = require('react-checkbox-group');
var FilterSettings = require('./constants');

var GuideFilter = React.createClass({

  getInitialState: function(){
    return {
      destinations: [],
      destination: this.props.destination || null,
      startingDate: this.props.startingDate || moment().add(7, 'days'),
      numDays: this.props.numDays || 3,
      pace: this.props.pace || 2,
      filter: this.props.filter || []
    };
  },
  
  //TODO: fix the onchange event for small screens
  handleChange: function(submitted) {
    if (this.props.isSmallScreen) {
      if (submitted) {
        this.props.onChange(this.state.numDays,
                            this.state.pace,
                            this.state.startingDate,
                            this.state.filter,
                            this.state.destination,
                            'list-view');
      } else {
        TweenLite.to(window, 0.6, {scrollTo:{y:0}, ease:Power2.easeOut});    
      }
    } else {
      this.props.onChange(this.state.numDays,
                          this.state.pace,
                          this.state.startingDate,
                          this.state.filter,
                          this.state.destination);
    }
  },

  handleDateChange: function(date, event) {
    if (date === '') {
      date = this.refs.startingDate.getDOMNode().value;
    }
    this.setState({startingDate: moment(date)}, function(){
      this.handleChange();
    });
  },

  getDayButtons: function() {
    var buttons = [];
    for(var i=1; i<=5; i++){
      var active = '';
      if (i === this.state.numDays) {
        active = ' active';
      }
      buttons.push(<a key={i} className={"btn btn-md btn-days"+active} onClick={this.handleDayChange.bind(this, i)}>{i}</a>);
    }
    return <div className="btns-filter">{buttons}</div>;
  },

  handleDayChange: function(day, event) {
    if (day !== this.state.numDays) {
      this.setState({numDays: day}, function(){
        this.handleChange();
      });
    }
  },

  changeOption: function(key, value){
    if (this.state[key] === value) return;

    this.state[key] = value;
    this.setState(this.state, function(){
      this.handleChange();
    })
  },

  getPaceButtons: function() {
    var buttons = [],
        paceLabels = ['Slow', 'Medium', 'Fast'];
    
    for(var i=1; i<=3; i++){
      var active = '';
      if (i === this.state.pace) {
        active = ' active';
      }
      buttons.push(<a key={i} className={"btn btn-md btn-days"+active} onClick={this.handlePaceChange.bind(this, i)}>{paceLabels[i-1]}</a>);
    }
    return <div className="btns-filter">{buttons}</div>;
  },

  getDestinationSelector: function(){
    var options = [];
    for (var i=0; i<this.state.destinations.length; i++){
      var dest = this.state.destinations[i];
      options.push(<option value={dest.id}>{dest.name}</option>)
    }

    return( 
      <div className='select-wrapper'>
        <select className='destination-selections'>{options}</select>
      </div> 
    );
  },

  handlePaceChange: function(pace, event) {
    if (pace !== this.state.pace) {
      this.setState({pace: pace}, function(){
        this.handleChange();
      });
    }
  },

  getDatePicker: function() {
    var userAgent = window.navigator.userAgent;
    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
      var date = moment(this.state.startingDate).format('YYYY-MM-DD');
      return (
        <div className="date-picker">
          <input style={{fontSize: 16, width: '80%'}} type="date" ref="startingDate" onChange={this.handleDateChange.bind(this, '')} value={date} />
        </div>
      );
    }

    //    return <DateTimePicker ref="startingDate" onChange={this.handleDateChange} value={moment(this.state.startingDate).toDate()} time={false} format={"MMM dd, yyyy"} finalView={"month"} />;
    return <DatePicker value={moment(this.state.startingDate).toDate()} format={"mmm dd, yyyy"} onChange={this.handleDateChange} />;
  },
  
  getFilters: function() {
    var that = this,
        filters = this.state.filter || [],
        choices = FilterSettings.values,
        toggles = [];

    choices.forEach(function(choice, i) {
      var label = FilterSettings.labelMap[choice],
          toggle =  <ToggleButton 
                      id={ choice } 
                      label={ label } 
                      status={ filters.indexOf(choice) !== -1 }
                      onToggle={ that.toggleFilterSelections.bind(that) }
                    />
      
      toggles.push(toggle)
      // checkboxes.push(<div className="col-sm-12 col-md-6 col-xs-5 filter-choice" key={i}>
      //                 <label className="filter-chk">
      //                 <input type="checkbox" value={choice} className="filter-chk"/>
      //                 <span className="filter-chk-target"></span>
      //                 </label>
      //                 {label}
      //                 </div>);
    });

    return (
        <div className="filter" ref="filter">
          {toggles}
        </div>
      );
  },

  toggleFilterSelections: function(item){
    var filters = this.state.filter,
        itemIndex = filters.indexOf( item );

    if (itemIndex !== -1){
      filters.splice(itemIndex, 1);
    } else {
      filters.push(item);
    }

    //TODO: this isn't good
    this.setState({ filter: this.state.filter });
    this.handleChange();
  },

  componentDidMount: function() {
    if (this.props.showDestinationSelector){
      this.serverRequest = $.getJSON("/api/destinations", function(resp){
        resp.unshift({id: null, name: "Select One"});
        this.setState({destinations: resp});
      }.bind(this));
    }
  },

  componentWillUnmount: function(){
    if (this.serverRequest) this.serverRequest.abort();
  },
  
  makeTrip: function(){
    var url =   '/api/trip/guide';
        url +=  '?destination=' + this.state.destination;
        url +=  '&num-days=' + this.state.numDays;
        url +=  '&pace=' + this.state.pace;
        url +=  '&start-date=' + this.state.startingDate.format("YYYY-MM-DD");
        url +=  '&filter=' + this.state.filter.join(",");

    window.location = url;
  },

  render: function(){
    var showButton = null;
    if (this.props.isSmallScreen) {
      if (this.props.mobileCurrentView !== 'filter-view') {
        return null;
      }
      showButton = <a href='#' onClick={this.handleChange.bind(null, true)}><i className="fa fa-arrow-left"></i> Back</a>;
    }
    
    var daysLabel = (this.props.numDays > 1) ? ' Days' : ' Day';

    var wideClass = this.props.showDateSelector ? "col-md-9 col-sm-8 col-xs-12" : "col-md-6 col-sm-4 col-xs-12",
        narrowClass = this.props.showDateSelector ? "col-md-4 col-sm-6 col-xs-12" : "col-md-6 col-xs-12"

    return (
      <div className='c_guide-filter'>
        <h2>{showButton}</h2>
        <div id="filter" className="col-xs-12">
          <p className='error-msg'>
            Please select a destination
          </p>

          { !this.props.showDestinationSelector ? null : 
            <div className="param col-md-3 col-sm-4 col-xs-12">
              <label>Destination</label>
              <StyledSelect options={ this.state.destinations } name='destination' onChange={ this.changeOption.bind(this, "destination") }/>
            </div>
          }
          <div className="param col-md-3 col-sm-4 col-xs-12">
            <label>Interests</label>
            {this.getFilters()}
          </div>
          <div className={ "param-wrapper " + wideClass }>
            <div className={ "param " + narrowClass }>
              <label>Days</label>
              {this.getDayButtons()}
            </div>
            <div className={ "param " + narrowClass }>
              <label>Pace</label>
              {this.getPaceButtons()}
            </div>
            { !this.props.showDateSelector ? null :
              <div className="param col-md-4 col-xs-12">
                <label>Starting on</label>
                {this.getDatePicker()}

              </div>
            }
          </div>
        </div>
      </div>
    );
  }
});

module.exports = GuideFilter;



// WEBPACK FOOTER //
// ./components/guide-filter.js